// libs/react-mosaic-component/src/lib/buttons/TabDragButton.tsx
import classNames from "classnames";
import React from "react";
import { MosaicContext } from "../contextTypes.mjs";
import { OptionalBlueprint } from "../util/OptionalBlueprint.mjs";
var TabDragButton = class extends React.PureComponent {
  static contextType = MosaicContext;
  render() {
    return this.props.connectDragSource(
      /* @__PURE__ */ React.createElement(
        "button",
        {
          title: "Drag to move",
          className: classNames(
            "mosaic-default-control",
            "mosaic-tab-drag-button",
            OptionalBlueprint.getClasses(this.context.blueprintNamespace, "BUTTON", "MINIMAL", "SMALL"),
            OptionalBlueprint.getIconClass(this.context.blueprintNamespace, "DRAG_HANDLE_VERTICAL")
          )
        }
      )
    );
  }
};
export {
  TabDragButton
};
